import React from 'react';
import KeyWordLandingPageComponent from 'src/areas/keyword-search-page/components/keyword-search-page';
import { KeywordSearchPageQuery } from '../../../types';
import KeywordSearchPage from './results';
import { useNewSearchApiKWLP } from 'src/hooks/experiments';

const KeyWordLandingPageWrapper = ({
  data,
}: {
  data: KeywordSearchPageQuery;
}) => {
  const newSearchExperiment = useNewSearchApiKWLP();

  if (newSearchExperiment) {
    return <KeywordSearchPage data={data} />;
  }
  return <KeyWordLandingPageComponent data={data} />;
};

export default KeyWordLandingPageWrapper;
